import React from "react";
import {ReactComponent as ViceCaptainActive} from "assets/img/icons/vice_captain.svg";
import {ReactComponent as ViceCaptainInactive} from "assets/img/icons/vice_captain_inactive.svg";

type IProps = {isViceCaptain: boolean};

export const ViceCaptain: React.FC<IProps> = ({isViceCaptain}) =>
	isViceCaptain ? <ViceCaptainActive /> : <ViceCaptainInactive />;
